var map = {
	"./amex.svg": "./src/assets/svg/payment-processing-networks-logos/amex.svg",
	"./cartes_bancaires.svg": "./src/assets/svg/payment-processing-networks-logos/cartes_bancaires.svg",
	"./diners.svg": "./src/assets/svg/payment-processing-networks-logos/diners.svg",
	"./discover.svg": "./src/assets/svg/payment-processing-networks-logos/discover.svg",
	"./jcb.svg": "./src/assets/svg/payment-processing-networks-logos/jcb.svg",
	"./mastercard.svg": "./src/assets/svg/payment-processing-networks-logos/mastercard.svg",
	"./unionpay.svg": "./src/assets/svg/payment-processing-networks-logos/unionpay.svg",
	"./visa.svg": "./src/assets/svg/payment-processing-networks-logos/visa.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg/payment-processing-networks-logos sync recursive ^\\.\\/.*\\.svg$";